import FileLoaderService from './fileLoaderService';
import { DicomMetadataStore } from '@ohif/core';

let GblVar = window.GblVar;
let listNewImages = [];
window.memoImagens = [{ Serie: "", ImageId: "" }];

const addInstancesBySeries = async (enabledVPElement) => {
  if (enabledVPElement) {
    if (GblVar.InitLoadImages) {
      const imageIds = enabledVPElement.viewport.imageIds;
      const listImagesBySerie = window.memoImagens.filter(x => x.Serie === GblVar.SerieActive); //IMAGEM JÁ CARREGADA

      var serieAtual = GblVar.SeriesCarregadas.find(x => x.Serie === GblVar.SerieActive);
      if (listImagesBySerie.length > serieAtual.Number) {
        GblVar.SeriesCarregadas.filter(item => item.Serie === GblVar.SerieActive)[0].ImageIds = imageIds;
      }
      else {
        await listImagesBySerie.forEach(obj => {
          const imageId = obj.ImageId;
          if (imageId) {
            const imageIdExist = imageIds.find(objImageId => objImageId === imageId);
            if (!imageIdExist) {
              imageIds.push(imageId);
            }
          }
        });
      }
    }
  }
}

// const addInstancesBySeries = async (enabledVPElement) => {
//   if (enabledVPElement) {
//     if (GblVar.InitLoadImages) {
//       const imageIds = enabledVPElement.viewport.imageIds;
//       await listNewImages.forEach(imageId => {
//         if (imageIds) {
//           const imageIdExist = imageIds.includes(imageId);
//           if (imageIdExist === false)
//             imageIds.push(imageId);
//         }
//       });
//       GblVar.SeriesCarregadas.filter(item => item.Serie === GblVar.SerieActive)[0].ImageIds = imageIds;
//       //MEMO IMAGENS
//       //memoImagensCarregadas
//     }
//   }
// }

const addImageToList = (imageId) => {
  if (GblVar.SeriesCarregadas.length > 1);
  listNewImages.push(imageId);
}

const addSerieToList = (serieNumber) => {
  if (GblVar.ListSeries.some(item => item.Serie === GblVar.SerieActive) === false && GblVar.SeriesCarregadas.some(item => item.Serie === GblVar.SerieActive) === false)
    GblVar.ListSeries.push({ Serie: GblVar.SerieActive, Number: serieNumber });
}

const processFile = async (file) => {
  try {
    GblVar = window.GblVar;
    const fileLoaderService = new FileLoaderService(file);
    const imageId = fileLoaderService.addFile(file);
    const image = await fileLoaderService.loadFile(file, imageId);
    const dicomJSONDataset = await fileLoaderService.getDataset(image, imageId);
    //console.log(imageId);
    GblVar.SerieActive = dicomJSONDataset.SeriesInstanceUID;
    addSerieToList(dicomJSONDataset.SeriesNumber);
    try {

      const imagemJaAdicionada = window.memoImagens.find(x => x.Serie === dicomJSONDataset.SeriesInstanceUID && x.SOPInstanceUID === dicomJSONDataset.SOPInstanceUID);
      if (imagemJaAdicionada === undefined) {
        window.memoImagens.push({ Serie: dicomJSONDataset.SeriesInstanceUID, ImageId: imageId, SOPInstanceUID: dicomJSONDataset.SOPInstanceUID });
      }

      /*/
      let serieCarregada = window.memoImagens.filter(x => x.Serie === dicomJSONDataset.SeriesInstanceUID);
      if (serieCarregada.length === 0) {
        window.memoImagens.push({ Serie: dicomJSONDataset.SeriesInstanceUID, Imagens: [] });
        serieCarregada = window.memoImagens.filter(x => x.Serie === dicomJSONDataset.SeriesInstanceUID);
      }
      if (serieCarregada[0].Imagens.includes(imageId))
        serieCarregada[0].Imagens.push(imageId);
      /*/

      // const serieImageIds = window.GblVar.SeriesCarregadas.filter(x => x.Serie === dicomJSONDataset.SeriesInstanceUID)[0];
      // if (serieImageIds.ImageIds === undefined)
      //   serieImageIds.ImageIds = GblVar.InitLoadImages ? [] : { Serie: GblVar.SerieActive };
      // if (serieImageIds.ImageIds.includes(imageId) === false)
      //   serieImageIds.ImageIds.push(imageId);
    } catch (error) {
      console.log(error);
    }
    //addImageToList(imageId);
    //addInstanceBySeries(imageId);
    //window.filesDicomAdd.push(imageId);
    //if (window.filesDicomAdd.includes(imageId) === false)
    //cornerstone.imageLoader.loadImage(imageId);

    try { DicomMetadataStore.addInstance(dicomJSONDataset); } catch { }
    let activeSerie = window.services.DisplaySetService.activeDisplaySets.find(
      serie => serie.SeriesInstanceUID === dicomJSONDataset.SeriesInstanceUID
    );

    if (!activeSerie) {
      try {
        window.services.displaySetService.makeDisplaySets([dicomJSONDataset]);
        activeSerie = window.services.DisplaySetService.activeDisplaySets.find(
          serie => serie.SeriesInstanceUID === dicomJSONDataset.SeriesInstanceUID
        );
      } catch (error) { }
    }

    if (activeSerie && !activeSerie.images.some(image => image.SOPInstanceUID === dicomJSONDataset.SOPInstanceUID)) {
      activeSerie.images.push(dicomJSONDataset);
    }

  } catch (error) {
    console.log(
      error.name,
      ':Error when trying to load and process local files:',
      error.message
    );
  }
};

export default async function filesToStudies(files, enabledVPElement) {
  listNewImages = [];
  const processFilesPromises = files.map(processFile);
  await Promise.all(processFilesPromises);
  await addInstancesBySeries(enabledVPElement);
  //if (GblVar.SeriesCarregadas.length === 1)
  //window.getImgsDCMBySerie();
  return DicomMetadataStore.getStudyInstanceUIDs();
}
